import { text } from "@/theme/colors";
import { FCC } from "@/types/common";
import { Typography } from "@mui/material";

type TLearnerFormTitleProps = {
  text: string;
  marginBottom?: string;
};

export const LearnerFormTitle: FCC<TLearnerFormTitleProps> = ({ text: titleText, marginBottom = "14px" }) => {
  return (
    <Typography variant="head20Bold" color={text.primary} mb={marginBottom}>
      {titleText}
    </Typography>
  );
};
